import { TicketCheckIcon } from 'lucide-react'

import { DelegateAction } from './types'
import { ActionRow } from '@/features/actions/components/action-row/ActionRow'
import { ActionRowBaseProps } from '@/features/actions/components/action-row/types'
import { Address } from '@/ui/atoms/address/Address'

export interface DelegateActionRowProps extends ActionRowBaseProps {
  action: DelegateAction
}

export function DelegateActionRow({ action: { delegate }, ...props }: DelegateActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={TicketCheckIcon} />
      <ActionRow.Title>
        Set delegate to <Address address={delegate} compact />
      </ActionRow.Title>
      <ActionRow.ErrorWarning />
      <ActionRow.Trigger>Delegate</ActionRow.Trigger>
    </ActionRow>
  )
}
